import styled from 'styled-components'

import MobileHeader from '~/shared/components/header/MobileHeader'
import WebHeader from '~/shared/components/header/WebHeader'
import useViewport from '~/shared/hooks/useViewport'
import theme from '~/shared/styles/theme'

function Header() {
  const viewport = useViewport()

  return (
    <Wrapper>
      {viewport <= theme.deviceSizes.xlarge ? <MobileHeader /> : <WebHeader />}
    </Wrapper>
  )
}

export default Header

const Wrapper = styled.div`
  z-index: ${theme.zIndex.header};
`
